/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useState } from "react";
import { Form } from "reactstrap";
import { InputGroupAddon, InputGroupText, Input} from "reactstrap";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  InputGroup,
} from "reactstrap";


const SelectTenant = () => {


  const [tenantId, setTenantId] = useState("");


  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent ">
            <div className="text-muted text-center ">
              <h2>Seleccionar empresa:</h2>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center"> 
              <Form role="form" onSubmit={(e) => {
                e.preventDefault();
                localStorage.setItem("tenant", tenantId);
                window.location.href = "/auth/login";
              }}>
                <FormGroup className="mb-3">
                  <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                    <Input 
                      placeholder="ID de la empresa" 
                      value={tenantId} 
                      onChange={(e) => setTenantId(e.target.value)} 
                    />
                  </InputGroup>
                </FormGroup>
                <div className="text-center">
                  <Button className="my-4" color="primary" type="submit" disabled={!tenantId}>
                    Continuar
                  </Button>
                </div>
              </Form>
            </div>
          </CardBody>
        </Card>
        
      </Col>
    </>
  );
};

export default SelectTenant;
